var SocialSSComplianceSolutions = {
  init: function() {
    this.setVariables();
    this.retrieveComplianceSolutions();
  },
  setVariables: function() {
    this.$complianceSolutionSection = $("#complianceSolutionSection");
	this.$complianceCount = $("#complianceSolutionCount");
  },
  retrieveComplianceSolutions: function() {
    var url = Config.contextPath + "/controller/view/solution/compliance?action=getComplianceIds";
    $.get(url)
      .done(this.handleResponse.bind(this));
  },
  handleResponse: function(r) {
    if (!r.needsCompliance) {
		this.$complianceSolutionSection.hide();
    }else{
		this.$complianceCount.html(r.count);
		this.$complianceCount.show();
		this.$complianceSolutionSection.show();
	}
  }
};